import React from 'react';

function MessageCard(props) {
    const { title, imgSrc, iconClass, message, titleClass = "msg-main-title", subTitleClass = "msg-sub-title", contClasses = "msg-block" } = props;
    return (
        <div className={`${contClasses}`}>
            {iconClass && <i className={`${iconClass} msg-icon`}></i>}
            {imgSrc && <img src={imgSrc} alt={title} />}
            <div className="msg-main-block">
                {title && <label className={titleClass}>{title}</label>}
                {message && <label className={subTitleClass}>
                    {message}
                </label>}
            </div>
        </div>
    )
}

export default MessageCard